export default "__VITE_ASSET__15a6553a__"